export function findVirtualSupplyLinkFor(formNumber: string) {
    return `https://secure02.principal.com/publicvsupply/GetFile?fm=${formNumber}&ty=VOP&EXT=.VOP`;
}

export function findAdobeSignLinkFor(documentId: string) {
    return `https://principal.na1.adobesign.com/public/esignWidget?wid=${documentId}`;
}